var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalSearchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7917 24.7917L31.1667 31.1667",
    stroke: "#2177FE",
    strokeWidth: 2.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 15.5833C28.3333 8.54171 22.625 2.83334 15.5833 2.83334C8.5417 2.83334 2.83333 8.54171 2.83333 15.5833C2.83333 22.625 8.5417 28.3333 15.5833 28.3333C22.625 28.3333 28.3333 22.625 28.3333 15.5833Z",
    stroke: "#2177FE",
    strokeWidth: 2.125,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSearchBlue);
export default __webpack_public_path__ + "static/media/ModalSearchBlue.89a013d932b244417e366011d2f06dda.svg";
export { ForwardRef as ReactComponent };